import { useEffect, useState, useRef } from 'react';
const useTypewriter = (text, start, speed = 10) => {
    const [output, setOutput] = useState('');
    const hasTypedRef = useRef(false);
    const indexRef = useRef(0);
    const intervalRef = useRef();
    useEffect(() => {
        if (!start || hasTypedRef.current)
            return;
        intervalRef.current = setInterval(() => {
            setOutput((prev) => {
                const nextChar = text.charAt(indexRef.current++);
                const updated = prev + nextChar;
                if (indexRef.current >= text.length) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = undefined;
                    hasTypedRef.current = true;
                }
                return updated;
            });
        }, speed);
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = undefined;
                if (!hasTypedRef.current) {
                    setOutput(text);
                    hasTypedRef.current = true;
                }
            }
        };
    }, [start, text, speed]);
    const isWriting = start && !hasTypedRef.current;
    return { text: output, isWriting };
};
export default useTypewriter;
